import React from 'react';
import Forms from '../components/Forms';
import Table from '../components/Table';

function Planets() {
  return (
    <div className="planets">
      <Forms />
      <Table />
    </div>
  );
}

export default Planets;
